import { useState, useEffect } from "react";
import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import axios from "axios";
import {
  btnOne,
  btnSmall,
  btnSmallTwo,
  btnWhite,
  label,
  title,
} from "../utils/style";
import uiConfigAtom from "../atoms/uiConfigAtom";
import { useRecoilState } from "recoil";
import formatNumberToUs from "../custom_functions/formatNumberToUs";

function AuditLog() {
  const workOrderOptions = [
    {
      header: "Manager",
      render: (data) => {
        return data?.firstName + " " + data?.lastName;
      },
      width: "20%",
    },
    {
      header: "Customer",
      key: "customerName",
      width: "20%",
    },
    {
      header: "Action Type",
      render: (data) => data.actionType,
      width: "20%",
    },
    {
      header: "Changes",
      render: (data) => {
        return (
          <p>
            <span style={{ color: "red", textDecoration: "line-through" }}>
              {data.actionType === "CREDIT_LIMIT_CHANGE"
                ? `$${formatNumberToUs(data.previousValue)}`
                : data.previousValue}
            </span>
            {" → "}
            <span style={{ color: "green", fontWeight: "bold" }}>
              {data.actionType === "CREDIT_LIMIT_CHANGE"
                ? `$${formatNumberToUs(data.newValue)}`
                : data.newValue}
            </span>
          </p>
        );
      },
      width: "20%",
    },

    {
      header: "Date",
      key: "date",
      render: (data) => {
        return new Date(data.createdAt).toLocaleDateString("en-US", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        });
      },
      placeHolder: "mm-dd-yyyy",
      width: "20%",
    },
  ];

  const excludeFilter = [
    "Customer",
    "Action Type",
    "Changes",
    "Date",
    "Manager",
  ];

  return (
    <div className='p-4'>
      <div className={title}>Audit Log</div>
      <Table
        url={url + "/credit_limit_log"}
        options={workOrderOptions}
        pagination
        noButton
        excludeFilter={excludeFilter}
      />
    </div>
  );
}

export default AuditLog;
